/** Interpret POST /chemical_inventories/analyze_document (HTTP 200 body). */

export function suggestedFromAnalyzeResponse(response) {
  const suggested = response?.data?.suggested;
  if (!suggested || typeof suggested !== "object" || Array.isArray(suggested)) {
    return null;
  }
  return suggested;
}

export function analyzeDocumentSucceeded(response) {
  if (!response || typeof response !== "object") return false;
  const errors = response.errors;
  if (Array.isArray(errors) && errors.length > 0) return false;
  return (
    suggestedFromAnalyzeResponse(response) != null ||
    Boolean(response?.data?.document_id)
  );
}

export function analyzeDocumentHasIdentity(suggested) {
  const name = String(suggested?.name || "").trim();
  const cas = String(suggested?.cas_number || "").trim();
  return Boolean(name || cas);
}

/** i18n key when analysis succeeded but no form values could be derived. */
export function analyzeEmptyCopyKey(emptyReason) {
  if (emptyReason === "weak_source_text") {
    return "chemical.inventory.ai_empty_unreadable";
  }
  return "chemical.inventory.ai_empty";
}

/** True when at least one mapped SDS field has a real value (not blank / default HMS 1). */
export function analyzeDocumentHasFilledFields(suggested) {
  if (!suggested || typeof suggested !== "object" || Array.isArray(suggested)) {
    return false;
  }

  return Object.entries(suggested).some(([key, value]) => {
    if (key === "hms_level") {
      const level = Number(value);
      return Number.isFinite(level) && level >= 2 && level <= 4;
    }
    return String(value ?? "").trim().length > 0;
  });
}
